/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_H1Inputs */

const en_diff_h1 = /** @type {(inputs: Diff_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Diff & Compare`)
};

const ko_diff_h1 = /** @type {(inputs: Diff_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 비교 & Diff`)
};

const ja_diff_h1 = /** @type {(inputs: Diff_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON比較＆Diff`)
};

/**
* | output |
* | --- |
* | "JSON Diff & Compare" |
*
* @param {Diff_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_h1 = /** @type {((inputs?: Diff_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_h1(inputs)
	if (locale === "ko") return ko_diff_h1(inputs)
	return ja_diff_h1(inputs)
});